module.exports = __webpack_public_path__ + "img/detail6-2.a1bfd2b6.png";